import axios from "axios";
import {WIT_API_CONFIG} from "../config/witApiConfig";

const witTrainingApiService = {
  async sendQueueEntry(entry, authToken) {
    const trainingKind = entry.trainingKind === 'entity' ? 'entity' : 'intent';
    const text = (entry.text || '').substring(0, 280);
    const entityValue = (entry.entityValue || '').trim();
    const entityStart = trainingKind === 'entity' ? text.indexOf(entityValue) : -1;

    if (trainingKind === 'entity' && (!entry.entityType || !entityValue || entityStart < 0)) {
      throw new Error('invalid_entity_training_entry');
    }

    const payloadEntry = trainingKind === 'entity'
      ? {
        text,
        entities: [{
          entity: entry.entityType,
          value: entityValue,
          body: entityValue,
          start: entityStart,
          end: entityStart + entityValue.length,
        }],
        traits: [],
      }
      : {
        text,
        intent: entry.intent,
        entities: [],
        traits: [],
      };

    const response = await axios.post(WIT_API_CONFIG.trainUrl, {
      entries: [payloadEntry],
    }, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },
};

export default witTrainingApiService;
